import buildImageUrl from '../../lib/media-url-maker'

const createMeta = (entity) => {
  const {
    headline,
    name,
    shareTitle,
    shareDescription,
    metaTitle,
    metaDescription
  } = entity
  const meta = []
  const title = shareTitle || metaTitle || name || headline
  const description = shareDescription || metaDescription
  if (description) {
    meta.push(
      { property: 'description', content: description },
      { property: 'og:description', content: description }
    )
  }
  meta.push({ property: 'og:title', content: title })
  const images = entity.images || entity.heroImages || entity.thumbnailImages
  if (images && images.length > 0) {
    meta.push({
      property: 'og:image',
      content: buildImageUrl({
        resource: images[0],
        width: 1200,
        height: 1200,
        mode: 'cover'
      })
    })
  }
  return meta
}

export default createMeta
